<div>
  <mat-label>{{title}}</mat-label>
</div><br>
<form #form="ngForm">
  <div *ngIf="shubetsu === 'eachFeedAndWeeksCount'">
    <mat-form-field class="input-margin">
      <mat-label>
        銘柄
      </mat-label>
      <input matInput required placeholder="銘柄"
             name="feedMeigara" [(ngModel)]="meisai.meigara">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        cp
      </mat-label>
      <input matInput required placeholder="cp"
             name="feedCp" [(ngModel)]="meisai.cp">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        ME
      </mat-label>
      <input matInput required placeholder="ME"
             name="feedME" [(ngModel)]="meisai.ME">
    </mat-form-field>
  </div>

  <div *ngIf="shubetsu === 'vaccineList'">
    <mat-form-field appearance="legacy" class="date-input input-margin">
      <mat-label>実施日</mat-label>
      <input matInput [matDatepicker]="jissjiDatePicker" [(ngModel)]="meisai.jisshiDate" name="jissjiDatePicker"
             (click)="jissjiDatePicker.open()" required readonly>
      <mat-datepicker-toggle matSuffix [for]="jissjiDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #jissjiDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        実施日齢
      </mat-label>
      <input matInput required placeholder="日齢" type="number" min="0"
             name="yoteiNichirei" [(ngModel)]="meisai.jisshiNichirei">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        ワクチン名
      </mat-label>
      <input matInput required placeholder="ワクチン名"
             name="vaccineName" [(ngModel)]="meisai.vaccineName">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        株
      </mat-label>
      <input matInput required placeholder="株"
             name="vaccineKabu" [(ngModel)]="meisai.vaccineKabu">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        メーカー
      </mat-label>
      <input matInput required placeholder="メーカー"
             name="maker" [(ngModel)]="meisai.maker">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        投与方法
      </mat-label>
      <input matInput required placeholder="投与方法"
             name="touyoHouhou" [(ngModel)]="meisai.touyoHouhou">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        ドース
      </mat-label>
      <input matInput placeholder="ドース" type="number" min="0"
             name="dose" [(ngModel)]="meisai.dose">
    </mat-form-field>
  </div>
</form>
<div mat-dialog-actions align="end">
  <button mat-button mat-flat-button color="primary" (click)="commonService.onClick(this.matDialogRef, meisai)" [disabled]="form.invalid || !form.dirty">
    <span>Enter</span>
  </button>
</div>

